<div class="content-container">
	<section class="data-table payment all-lists">
		<payments-header *ngIf="activeTab != 'view-invoice'"
			[allInvoicesSum]="allInvoicesSum"
			[closedInvoicesSum]="closedInvoicesSum"
			[pendingInvoicesSum]="pendingInvoicesSum"
			[userInfo]="userInfo"
		></payments-header>

		<div class="data-table__wrap">

			<payments-tab-header
				[invoicesCount]="invoicesCount"
				[receivedPaymentsCount]="receivedPaymentsCount"
				[failedPaymentsCount]="failedPaymentsCount"
				[draftsCount]="draftsCount"
				[activeTab]="activeTab"
				(changeTab)="switchTab($event)"
				(onSearch)="searchInvoices($event)"
				(recordPayment)="recordPayment()"
				(toggleTableMenu)="toggleTableMenu()"
				(filterByDate)="filterByDate($event)"
				(filterByAmount)="filterByAmount($event)"
				(filterByStatus)="filterByStatus($event)"
				[userInfo]="userInfo"
			></payments-tab-header>

			<div [hidden]="activeTab !== 'received-payments'" >
				<teemapp-table
					[name]="'received-payments'"
					[tableSchema]="receivedPaymentsTable"
					[selectable]="false"
					[divClass]="'payment__success'"
					(onLoad)="onLoadReceivedPayments($event)"
					#receivedPaymentsTableRef
				></teemapp-table>
			</div>

			<div [hidden]="activeTab !== 'pending-payments'" >
				<teemapp-table
					[name]="'pending-payments'"
					[tableSchema]="pendingPaymentsTable"
					[selectable]="false"
					(onLoad)="onLoadPendingInvoices($event)"
					[divClass]="'payment__success'"
					#pendingPaymentsTableRef
				></teemapp-table>
			</div>

			<div [hidden]="activeTab !== 'failed-payments'" >
				<teemapp-table
					[name]="'failed-payments'"
					[tableSchema]="failedPaymentTable"
					[selectable]="false"
					(onLoad)="onLoadFailedInvoices($event)"
					[divClass]="'payment__success'"
					#failedPaymentTableRef
				></teemapp-table>
			</div>

			<div *ngIf="activeTab == 'view-invoice'" >
				<view-invoice
					[invoiceDetail]="activeInvoice"
					(onEdit)="editInvoice($event)"
					(doAction)="doAction($event)"
					(payIncash)="payIncash($event)"
					(onDelete)="onDeleteInvoice($event)"
					(onView)="viewInvoice($event)"
					(changeTab)="switchTab($event)"
					(recordPayment)="recordNewPayment($event)"
					[isPaymentTab]="isPaymentTab" 
				></view-invoice>
			</div>
			

		</div>
	</section>
</div>
